import React from "react";

import { cleanSpecialCharacters } from "../../extras";
import LabelHorizontal from "../labels/LabelHorizontal";
import ChannelReportSummaryRow from "./ChannelReportSummaryRow";
import { DividerBlackOnPrint } from "../styled";
import { HistoryReportGroupStackPrint } from "../styled/stack";

export default function ChannelPOSReportSummary({ label = "BALCÃO", data }) {
  return (
    <HistoryReportGroupStackPrint spacing={1} sx={{ mt: 2 }}>
      <LabelHorizontal label={label} align="center" isbold />
      <DividerBlackOnPrint />
      <ChannelReportSummaryRow
        method="Online"
        finance={data.online_finance}
        amount={data.online_amount}
      />

      <ChannelReportSummaryRow
        method="Dinheiro"
        finance={data.money_finance}
        amount={data.money_amount}
      />

      <ChannelReportSummaryRow
        method="Maquininha"
        finance={data.card_finance}
        amount={data.card_amount}
      />

      {data.vale_worker_amount > 0 && (
        <ChannelReportSummaryRow
          method="Vale Funcionário"
          finance={data.vale_worker_finance}
          amount={data.vale_worker_amount}
        />
      )}

      {data.vale_refeicao_amount > 0 && (
        <ChannelReportSummaryRow
          method="Vale Refeição"
          finance={data.vale_refeicao_finance}
          amount={data.vale_refeicao_amount}
        />
      )}

      {data.vale_outsider_amount > 0 && (
        <ChannelReportSummaryRow
          method="Vale Externo"
          finance={data.vale_outsider_finance}
          amount={data.vale_outsider_amount}
        />
      )}

      {data.vale_fuel_amount > 0 && (
        <ChannelReportSummaryRow
          method="Vale Combustível"
          finance={data.vale_fuel_finance}
          amount={data.vale_fuel_amount}
        />
      )}

      {data.vale_alimentacao_amount > 0 && (
        <ChannelReportSummaryRow
          method="Vale Alimentação"
          finance={data.vale_alimentacao_finance}
          amount={data.vale_alimentacao_amount}
        />
      )}

      {data.pos_custom_payment_methods.map((method) => (
        <ChannelReportSummaryRow
          method={cleanSpecialCharacters(method.title)}
          finance={method.total_value}
          amount={method.order_count}
        />
      ))}

      <ChannelReportSummaryRow
        method="Total"
        finance={data.finance}
        amount={data.orders}
        isBold
      />
    </HistoryReportGroupStackPrint>
  );
}
